import { Linkedin, Twitter, Mail, Users, Award, Star } from 'lucide-react';
import { Footer } from '../components/Footer';
import { HomeHeader } from '../components/HomeHeader';

const teamMembers = [
  {
    name: 'John Smith',
    role: 'CEO & Founder',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&w=400&h=400&q=80',
    bio: 'With 15+ years in renewable energy, John leads our mission to make solar accessible to all.',
    linkedin: '#',
    twitter: '#',
    email: 'john@gasable.com'
  },
  {
    name: 'Sarah Johnson',
    role: 'Technical Director',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=400&h=400&q=80',
    bio: 'Sarah oversees all technical aspects of our solar installations and system designs.',
    linkedin: '#',
    twitter: '#',
    email: 'sarah@gasable.com'
  },
  {
    name: 'Michael Chen',
    role: 'Head of Engineering',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=400&h=400&q=80',
    bio: 'Michael brings extensive experience in solar system optimization and innovation.',
    linkedin: '#',
    twitter: '#',
    email: 'michael@gasable.com'
  },
  {
    name: 'Emily Davis',
    role: 'Customer Success Manager',
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=400&h=400&q=80',
    bio: 'Emily ensures our clients receive the best possible service and support throughout their solar journey.',
    linkedin: '#',
    twitter: '#',
    email: 'emily@gasable.com'
  }
];

export function OurTeam() {
  return (
    <div className="min-h-screen bg-white">
      <HomeHeader />
      
      <main>
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Meet Our Team
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Dedicated professionals committed to bringing sustainable energy solutions to homes and businesses.
            </p>
          </div>
        </div>

        {/* Values Section */}
        <div className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">Our Values</h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                These core values guide everything we do and help us deliver exceptional service to our clients.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Users className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Customer First</h3>
                <p className="text-gray-600">
                  We prioritize our customers' needs and ensure their complete satisfaction.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Award className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Excellence</h3>
                <p className="text-gray-600">
                  We strive for excellence in every project and installation we undertake.
                </p>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg text-center">
                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Star className="h-8 w-8 text-purple-600" />
                </div>
                <h3 className="text-xl font-bold mb-4">Innovation</h3>
                <p className="text-gray-600">
                  We continuously innovate to provide the best solar solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Team Members */}
        <div className="py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4">Leadership Team</h2>
              <p className="text-gray-600 max-w-3xl mx-auto">
                Meet the experts leading our mission to revolutionize solar energy adoption.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-64 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-bold mb-2">{member.name}</h3>
                    <p className="text-blue-600 font-medium mb-4">{member.role}</p>
                    <p className="text-gray-600 mb-4">{member.bio}</p>
                    <div className="flex space-x-4">
                      <a href={member.linkedin} className="text-gray-400 hover:text-blue-600">
                        <Linkedin className="h-5 w-5" />
                      </a>
                      <a href={member.twitter} className="text-gray-400 hover:text-blue-400">
                        <Twitter className="h-5 w-5" />
                      </a>
                      <a href={`mailto:${member.email}`} className="text-gray-400 hover:text-blue-600">
                        <Mail className="h-5 w-5" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Join Our Team */}
        <div className="bg-blue-600 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6">Join Our Team</h2>
            <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
              We're always looking for talented individuals who share our passion for renewable energy.
            </p>
            <button className="bg-white text-blue-600 py-3 px-8 rounded-lg hover:bg-blue-50 font-medium">
              View Open Positions
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}